import classNames from 'classnames';
import styles from './ModuleContainer.module.scss';

export interface ModuleContainerSettings {
	properties?: {
		moduleMarginBottom: string;
		moduleMarginBottomOverride?: string;
	}
}

export interface ModuleContainerProps extends ModuleContainerSettings {
	children: React.ReactNode;
	width?: 'fullWidth';
}

export const ModuleContainer: React.FC<ModuleContainerProps> = ({ children, properties, width }) => {
	let marginBottom = 'default';

	if (properties !== undefined) {
		const { moduleMarginBottom, moduleMarginBottomOverride } = properties;
		marginBottom = moduleMarginBottomOverride || moduleMarginBottom || 'default';
	}

	if (marginBottom === 'Ingen luft') {
		marginBottom = 'zero';
	}

	return (
		<div className={classNames(styles.ModuleContainer, styles[`ModuleContainer___${marginBottom.toLowerCase()}`], {
			[styles.ModuleContainer___fullWidth]: width,
		} )}>{children}</div>
	);
};